const chunkMapping = {
	"738": [
		5316,
		13668,
		21192,
		30814,
		47594,
		71205,
		75784,
		82988,
		90686,
		92910
	]
};
const idToExternalAndNameMapping = {
	"5316": [
		"default",
		"./MainLayout",
		95243
	],
	"13668": [
		"default",
		"./OverrideStyle",
		95243
	],
	"21192": [
		"default",
		"./NotFound",
		95243
	],
	"30814": [
		"default",
		"./AppInput",
		95243
	],
	"47594": [
		"default",
		"./AppSelect",
		95243
	],
	"71205": [
		"default",
		"./AppCustomizedPagination",
		95243
	],
	"75784": [
		"default",
		"./IconSvg",
		95243
	],
	"82988": [
		"default",
		"./AppTextArea",
		95243
	],
	"90686": [
		"default",
		"./IndexStyle",
		95243
	],
	"92910": [
		"default",
		"./LayoutStyle",
		95243
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}